import {
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    Typography,
} from '@mui/material'
import styles from 'components/Sell/payment/paymentDialog.style'
import { ReactNode } from 'react'

interface IPaymentDetailRow {
    label: ReactNode
    value: string | ReactNode
    isBold?: boolean
    highlightValue?: boolean
}

function PaymentDetailRow({
    label,
    value,
    isBold = false,
    highlightValue = false,
}: IPaymentDetailRow) {
    return (
        <ListItem sx={{ maxHeight: 35 }}>
            <ListItemText
                primary={
                    <Typography
                        variant="subtitle1"
                        sx={{
                            ...styles.detailTextFontMobile,
                            fontWeight: isBold ? 700 : 0,
                        }}
                    >
                        {label}
                    </Typography>
                }
            />
            <ListItemSecondaryAction>
                {typeof value === 'string' ? (
                    <Typography
                        sx={{
                            ...styles.detailTextFontMobile,
                            fontWeight: isBold ? 700 : 0,
                        }}
                        color={highlightValue ? 'primary' : 'secondary'}
                    >
                        {value}
                    </Typography>
                ) : (
                    <>{value}</>
                )}
            </ListItemSecondaryAction>
        </ListItem>
    )
}
export default PaymentDetailRow
